/* SMS product messaging: one SDK, refresh only after readiness, existing form events. */
(() => {
  if (customElements.get('sms-affirm-promo')) return;
  let sdkReady;
  let refreshQueued = false;

  function ensureSdk(publicKey) {
    if (sdkReady) return sdkReady;
    sdkReady = new Promise((resolve, reject) => {
      if (!window.affirm?.ui?.ready) {
        const config = {public_api_key: publicKey, script: 'https://cdn1.affirm.com/js/v2/affirm.js', locale: 'en_US', country_code: 'USA'};
        // Affirm's documented v2 bootstrap queues initialization and ui.ready.
        (function(l,g,m,e,a,f,b){var d,c=l[m]||{},h=document.createElement(f),n=document.getElementsByTagName(f)[0],k=function(a,b,c){return function(){a[b]._.push([c,arguments])}};c[e]=k(c,e,'set');d=c[e];c[a]={};c[a]._=[];d._=[];c[a][b]=k(c,a,b);a=0;for(b='set add save post open empty reset on off trigger ready setProduct'.split(' ');a<b.length;a++)d[b[a]]=k(c,e,b[a]);a=0;for(b=['get','token','url','items'];a<b.length;a++)d[b[a]]=function(){};h.async=true;h.src=g[f];h.onerror=()=>reject(new Error('Affirm SDK could not load'));n.parentNode.insertBefore(h,n);delete g[f];d(g);l[m]=c})(window,config,'affirm','checkout','ui','script','ready');
      }
      window.affirm.ui.ready(() => {
        if (typeof window.affirm.ui.refresh === 'function') resolve();
        else reject(new Error('Affirm SDK did not expose refresh'));
      });
    });
    return sdkReady;
  }

  function refresh(publicKey) {
    if (refreshQueued) return;
    refreshQueued = true;
    ensureSdk(publicKey).then(() => {
      refreshQueued = false;
      window.affirm.ui.refresh();
    }).catch(error => {
      refreshQueued = false;
      console.warn('[SMS Affirm] Product messaging unavailable.', error);
    });
  }

  class SMSAffirmPromo extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.form = document.getElementById(this.dataset.formId);
      this.promo = this.querySelector('.affirm-as-low-as');
      if (!this.form || !this.promo || !this.dataset.publicKey) return;
      try { this.prices = JSON.parse(this.querySelector('[data-sms-affirm-prices]').textContent); }
      catch (error) { this.hidden = true; return; }
      this.form.addEventListener('variant:change', event => {
        const variant = event.detail?.variant;
        if (variant?.id && Number.isFinite(Number(variant.price))) this.prices[String(variant.id)] = Number(variant.price);
        this.update();
      }, {signal: this.controller.signal});
      this.form.addEventListener('change', () => this.update(), {signal: this.controller.signal});
      this.observer?.disconnect();
      this.observer = new MutationObserver(() => this.update());
      this.observer.observe(this.form, {subtree: true, childList: true, attributes: true, attributeFilter: ['value', 'disabled']});
      this.update(true);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }

    update(force = false) {
      const id = this.form.querySelector('[name="id"]');
      const amount = id && !id.disabled && id.value ? this.prices[id.value] : undefined;
      const valid = Number.isFinite(amount) && amount > 0;
      const wasHidden = this.hidden;
      this.hidden = !valid;
      if (!valid) return;
      if (force || wasHidden || this.promo.dataset.amount !== String(amount)) {
        this.promo.dataset.amount = String(amount);
        refresh(this.dataset.publicKey);
      }
    }
  }
  customElements.define('sms-affirm-promo', SMSAffirmPromo);
})();
